export const version = 'V.2.00.M.20261022'